import { Autocomplete, Stack, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import messages from "./module/messages";
import {
  addReportInput,
  reportCampaignNameRequest,
  reportValue,
} from "./module/actions";
import { selectCampaignNames } from "./module/selectors";
import classes from "./ReportStepTwo/ReportStepTwo.module.scss";

interface ReportAutocompleteFieldProps {
  id: number;
  parameter: string;
  label: string;
  property: string;
  listType: string;
  campaignNames: string[];
  addReportInput: (
    value: any,
    id: any,
    parameter: any,
    label: any,
    property: any
  ) => void;
  getCampaignNames: () => void;
  setInputLabelValue: (value: any, id: any) => void;
}

enum REPORT_LIST_TYPE {
  CAMPAIGNS_NAMES = "CAMPAIGNS_NAMES",
}

function ReportAutocompleteField({
  id,
  label,
  parameter,
  property,
  listType,
  campaignNames,
  addReportInput,
  getCampaignNames,
  setInputLabelValue,
}: ReportAutocompleteFieldProps) {
  const [showedLabel, setShowedLabel] = useState<JSX.Element>();
  const [list, setList] = useState<any[]>([]);
  const [value, setValue] = useState<any>();

  useEffect(() => {
    addReportInput(value, id, parameter, label, property);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (listType.toUpperCase() === REPORT_LIST_TYPE.CAMPAIGNS_NAMES) {
      setShowedLabel(
        <FormattedMessage {...messages[REPORT_LIST_TYPE.CAMPAIGNS_NAMES]} />
      );
      getCampaignNames();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listType]);

  useEffect(() => {
    if (campaignNames.length > 0) {
      setList(campaignNames);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignNames]);

  useEffect(() => {
    if (value) {
      setInputLabelValue(value, id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const defaultProps = {
    options: list,
    getOptionLabel: (option: { id: number; value: string }) =>
      `${option.value}`,
  };

  const handleChangeItem = (item: { id: number; value: string }) => {
    setValue(item.value);
  };

  return (
    <div>
      <span className={classes["input-wrapper-description"]}>
        {showedLabel}
      </span>
      <Stack spacing={1} sx={{ width: "100%" }}>
        <Autocomplete
          {...defaultProps}
          fullWidth
          id="auto-complete-responsible"
          autoComplete
          includeInputInList
          onChange={(e: any, value: any) => handleChangeItem(value)}
          renderInput={(params) => (
            <>
              <div
                className={classes["textfield-wrapper"]}
                style={{ textAlign: "center" }}
              >
                <div className={classes["textfield-input"]}>
                  <TextField
                    {...params}
                    className={classes["textfield-input"]}
                    variant="filled"
                    size="small"
                    fullWidth
                    key={id}
                    id={`${id}`}
                  />
                </div>
              </div>
            </>
          )}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.value}
            </li>
          )}
        />
      </Stack>
    </div>
  );
}

const mapStateToProps: any = () =>
  createStructuredSelector({
    campaignNames: selectCampaignNames,
  });

const mapDispatchToProps: any = {
  addReportInput: (
    value: any,
    id: any,
    parameter: any,
    label: any,
    property: any
  ) => addReportInput({ value, id, parameter, label, property }),
  getCampaignNames: reportCampaignNameRequest,
  setInputLabelValue: (value: any, id: any) => reportValue({ value, id }),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(ReportAutocompleteField);
